import { Reveal } from "./motion";
import { MANIFESTO, MANIFESTO_IMAGE } from "../data";

export default function Manifesto() {
  return (
    <section data-testid="manifesto" className="relative bg-[#030303] py-20 md:py-32 overflow-hidden">
      <div className="absolute right-0 top-0 h-full w-1/2 hidden lg:block">
        <img src={MANIFESTO_IMAGE} alt="Black sports car profile" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#030303] via-transparent to-transparent" />
      </div>

      <div className="relative max-w-[1600px] mx-auto px-5 md:px-10">
        <Reveal>
          <p className="text-xs tracking-[0.3em] uppercase text-[#FF3B30] mb-4">The standard</p>
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl md:text-6xl leading-none max-w-2xl">
            Why owners across Adelaide trust us with their pride.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:max-w-4xl">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.n} delay={i * 0.1}>
              <div className="border-t border-zinc-700 pt-5">
                <p className="font-display font-bold text-5xl text-stroke mb-4">{m.n}</p>
                <h3 className="font-display uppercase tracking-tight text-lg mb-2">{m.title}</h3>
                <p className="text-zinc-400 text-sm leading-relaxed">{m.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
